// removed by extract-text-webpack-plugin
module.exports = {"HeaderBody":"HeaderBody---2AUBH"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/customer/EndUserAttributesCard/AttributesModal/HeaderBody.styl
// module id = XK6v
// module chunks = 89